import { apiSlice } from "../api/apiSlice";
import getPaginationInfo from "../../utils/getPaginationInfo";
import paramConfig from "../../config/paramConfig";

export const tagsSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTags: builder.query({
      query: ({ page = 1, pageSize = 600 }) =>
        `/tags?${paramConfig.PAGE_NUMBER}=${page}&${paramConfig.PAGE_SIZE}=${pageSize}`,
      transformResponse: (response, meta) => {
        const pagination = getPaginationInfo(meta);
        return { response, pagination };
      },
      providesTags: (result, error, arg) => [
        { type: "Tags" },
        { type: "Tags", id: arg?.page },
        { type: "Tags", id: arg?.pageSize },
      ],
    }),
    getTagSpectra: builder.query({
      query: ({ tagId }) => `/tags/${tagId}/spectra`,
      providesTags: (result, error, arg) => [
        {
          type: "SpectraByTag",
          id: `${arg?.tagId}-${arg?.tagId}`,
        },
      ],
    }),
    postTag: builder.mutation({
      query: ({ body }) => {
        return {
          url: `/tags`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: [{ type: "Tags" }],
    }),
  }),
});

export const { useGetTagsQuery, useGetTagSpectraQuery, usePostTagMutation } =
  tagsSlice;
